import { injectStyle } from '@edicom/common/tool/injectStyle';
import { injectRule } from '@edicom/common/tool/injectRule';

function styleInject(css = '', name, { insertBefore = false } = {}) {
  console.warn('styleInject is DEPRECATED, usar injectStyle');
  if (!css || typeof document === 'undefined') {
    return;
  }

  const head = document.head || document.getElementsByTagName('head')[0];
  const style =
    document.querySelector(`#${name}`) ||
    (function() {
      const style = document.createElement('style');
      style.type = 'text/css';
      style.id = name;
      insertBefore ? head.insertBefore(style, head.firstElementChild) : head.appendChild(style);
      return style;
    })();

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

export default {
  styleInject, // @odeniel DEPRECATED
  injectStyle,
  injectRule,
};
